import { useQuery } from "@tanstack/react-query";
import { getTask } from "../service/task.service";

export const useTask = (taskId: string | null) => {
  return useQuery({
    queryKey: ["task", { id: taskId }],
    queryFn: () => getTask(taskId || ""),
    enabled: !!taskId,
    staleTime: 1000 * 60, // 1 minute stale time
  });
};
